// Copyright (c) 2025 Deere & Company

import {FormattedMessage} from 'react-intl';
import React from 'react';

const SupportPanel = () =>
    <div className='useful-links-panel'>
        <header>
            <FormattedMessage id='Resources'/>
        </header>
        <div className='links'>
            <ul className='link-list'>
                <li>
                    <button
                        className='email-support-button side-bar-button'
                        onClick={() => {

                            window.location.href = 'mailto:RGADatamartSupport@JohnDeere.com';

                        }}
                    >
                        <FormattedMessage id='Get Help'/>
                    </button>
                </li>
                <li>
                    <button
                        className='email-support-button side-bar-button'
                        onClick={() => {

                            window.open('https://johndeere.hosted.panopto.com/Panopto/Pages/Viewer.aspx?id=7c76891e-4ca9-48d9-880c-b3090016462a&start=0&_sm_vck=F276skjRN4Vq7SVvW8kvN2WqPMVDvSqM802q7DQ80sJskF1j8W4j', '_blank');

                        }}
                    >
                        <FormattedMessage id='Tutorials'/>
                    </button>
                </li>
            </ul>
        </div>
    </div>;

SupportPanel.displayName = 'SupportPanel';

export default SupportPanel;



// WEBPACK FOOTER //
// ./src/rga/search/components/support-panel.js